import React, { useState } from "react";
import { Container, Form, Button } from "react-bootstrap";
import "./ForgotPassword.css";
import illustration from "../../../assets/ilustracao.png";
import logo from "../../../assets/Logo.png";
import { requestPasswordReset } from "../../../api/auth/forgot_password";
import FlashMessage from "../../../components/common/FlashMessage";
import { useFlashMessage } from "../../../hooks/useFlashMessage";

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const { message, type, showMessage, clearMessage } = useFlashMessage(5000);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    requestPasswordReset(email)
      .then(() => {
        showMessage(
          "Verifique seu e-mail para o link de redefinição de senha.",
          "success"
        );
        setLoading(false);
        return;
      })
      .catch((error) => {
        showMessage("Email inválido.", "error");
        setLoading(false);
      });
  };

  return (
    <Container fluid className="login-container">
      {message && (
        <div
          style={{
            position: "fixed",
            top: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 9999,
            minWidth: "400px",
          }}
        >
          <FlashMessage message={message} type={type} onClose={clearMessage} />
        </div>
      )}
      <div className="left-section">
        <div className="branding">
          {<img src={logo} alt="Logo" className="logo" />}
          <span className="brand-name">Insecta</span>
        </div>

        <div className="login-content">
          <h1 className="title">Esqueceu a senha?</h1>
          <p className="subtitle title">
            Escreva seu e-mail adicionado
            <br />
            no momento do cadastro e<br />
            receba um link para cadastrar
            <br />
            nova senha.
          </p>
        </div>

        <div className="illustration-container">
          {<img src={illustration} alt="Ilustração" className="illustration" />}
        </div>
      </div>

      <div className="right-section">
        <div className="form-container">
          <p className="form-title">Insira suas informações abaixo</p>
          <Form onSubmit={handleSubmit} className="login-form">
            <Form.Group className="mb-3">
              <Form.Control
                type="email"
                placeholder="Insira seu e-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="form-input"
              />
            </Form.Group>

            <Button type="submit" className="login-button" disabled={loading}>
              {loading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{ width: "1rem", height: "1rem" }}
                ></span>
              ) : (
                "Receber link"
              )}
            </Button>
          </Form>
        </div>
      </div>
    </Container>
  );
};

export default ForgotPassword;
